import {
  FormSelect,
} from '../../../../../components';
import { Col, Row } from 'antd';

const GestorStatus = ({
  goodStates,
  detailData,
  formikSolicitud,
  label_status,
}: any) => {
  const handleDefaultValue = () => {
    const idMatchValue = goodStates?.find((state: any) =>
      state.name === detailData?.status ? state.id : ''
    );

    if (idMatchValue) {
      formikSolicitud.setFieldValue('status_id', idMatchValue.id)
    }
    if (idMatchValue) return formikSolicitud.values.status_id
    else return ''
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <FormSelect
            label={label_status}
            name="status_id"
            placeholder="Seleccione"
            value={formikSolicitud.values.status_id || handleDefaultValue()}
            options={goodStates}
            error={formikSolicitud.errors.status_id}
            touched={formikSolicitud.touched.status_id}
            onChange={(value) =>
              formikSolicitud.setFieldValue('status_id', value)
            }
            onBlur={formikSolicitud.handleBlur}
          />
        </Col>
      </Row>
    </>
  );
};

export default GestorStatus;
